import React, { useEffect, useState } from "react";
import UserAvatar from "../UserAvatar";
import { Link, useParams } from "react-router-dom";
import {
  OwnerVerificationApprovedEmailBody,
  OwnerVerificationRejectedEmailBody,
  RenterVerificationApprovedEmailBody,
  RenterVerificationRejectedEmailBody,
  getOwnerMetaByID,
  getReferralCodeByUserId,
  getUserByID,
  getUserMetaByID,
  getDateOfBirthFromUserMeta,
  getUserAgeFromMeta,
  proMemberRejectedStatusBody,
  proMemberStatusBody,
  sendEmail,
  updateProStaffStatus,
  updateUserStatusById,
  updateBoatVerificationStatus,
  BASS_BOAT_TYPE,
  isVerificationStatusActive,
  parseVerificationUploadedFiles,
  formatVerificationAnswerForDisplay,
  inferVerificationQuestionType,
  getRenterVerificationSummary,
} from "../utils";
import {
  notifyRenterVerificationApproved,
  notifyRenterVerificationRejected,
} from "../utils/userNotifications";
import { Button, Col, Row } from "react-bootstrap";
import { getDatabase, push, ref, update } from "firebase/database";
import { Alert } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";
import { useDateRangePickerDefaultizedProps } from "@mui/x-date-pickers-pro/DateRangePicker/shared";

const getAdminVerificationStatusLabel = (status) => {
  if (isVerificationStatusActive(status)) {
    return "Approved";
  }

  const normalized = String(status || "unset").toLowerCase();
  if (normalized === "pending") return "Pending";
  if (normalized === "reject") return "Denied";
  return status || "unset";
};

const getAdminVerificationStatusClassName = (status) => {
  if (isVerificationStatusActive(status)) {
    return "admin-verification-status admin-verification-status--approved";
  }

  if (String(status || "").toLowerCase() === "pending") {
    return "admin-verification-status admin-verification-status--pending";
  }

  if (String(status || "").toLowerCase() === "reject") {
    return "admin-verification-status admin-verification-status--denied";
  }

  return "admin-verification-status admin-verification-status--unset";
};

const sortBoatVerificationsForAdmin = (entries) =>
  [...entries].sort(([, verificationA], [, verificationB]) => {
    const priority = (status) =>
      String(status || "").toLowerCase() === "pending" ? 0 : 1;

    const priorityDiff =
      priority(verificationA?.status) - priority(verificationB?.status);
    if (priorityDiff !== 0) {
      return priorityDiff;
    }

    return 0;
  });

export default function User() {
  const { dynamicId } = useParams();
  const [userData, setUserData] = useState(null);
  const [userMeta, setUserMeta] = useState(null);
  const [ownerMeta, setownerMeta] = useState(null);
  const [referralCode, setReferralCode] = useState(null);
  const [allQuestions, setAllQuestions] = useState([]);
  const [payoutAccounts, setPayoutAccounts] = useState(null);
  const [initialStatus, setInitialStatus] = useState("Pending");
  const [rejectionReason, setRejectionReason] = useState("");
  const [boatVerificationStatuses, setBoatVerificationStatuses] = useState({});
  const [boatVerificationRejections, setBoatVerificationRejections] = useState(
    {}
  );
  const [boatVerificationLoading, setBoatVerificationLoading] = useState({});

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // const userDetails = await getUserByID(dynamicId);
        // const userMetaDetails = await getUserMetaByID(dynamicId);
        // const ownerMetaDetails = await getOwnerMetaByID(dynamicId);
        // const ReferralCodeByUserId = await getReferralCodeByUserId(dynamicId);
        // const userAnswers = userMetaDetails.userAnswers;
        // let allQuestions = [];
        // if (userDetails.role === "Boat Owner") {
        //   if (userAnswers.textQuestions) {
        //     allQuestions = [...userAnswers.textQuestions];
        //   } else {
        //     allQuestions = [];
        //   }
        // } else {
        //   allQuestions = [];
        //   if (userAnswers.multiChoiceQuestions) {
        //     allQuestions = [
        //       ...allQuestions,
        //       ...userAnswers.multiChoiceQuestions,
        //     ];
        //   }
        //   if (userAnswers.textQuestions) {
        //     allQuestions = [...allQuestions, ...userAnswers.textQuestions];
        //   }
        // }

        // allQuestions.sort(
        //   (a, b) => (a.questionIndex || 0) - (b.questionIndex || 0)
        // );
        // const questionsWithAnswers = allQuestions.map(
        //   ({ question, answer }) => ({ question, answer })
        // );

        // setReferralCode(ReferralCodeByUserId);
        // setUserData(userDetails);
        // updateUser({
        //   firstName: userDetails.firstName,
        //   lastName: userDetails.lastName,
        //   role: userDetails.role,
        //   status: userDetails.status,
        //   phone: userDetails.phone,
        //   avatar: userDetails.avatar,
        // });
        // setAllQuestions(questionsWithAnswers);
        // setRejectionReason(userDetails.rejectionReason);
        // setUserMeta(userMetaDetails);
        // setownerMeta(ownerMetaDetails);
        // // Check if 'payoutAccounts' is available in 'ownerMetaDetails'
        // if (ownerMetaDetails && ownerMetaDetails.payoutAccounts) {
        //   setPayoutAccounts(ownerMetaDetails.payoutAccounts);
        // }
        // // Set the initial value of the select based on userData.status
        // setInitialStatus(userDetails.status || "Pending");
        const userDetails = await getUserByID(dynamicId);
        const userMetaDetails = await getUserMetaByID(dynamicId);
        const ownerMetaDetails = await getOwnerMetaByID(dynamicId);
        const ReferralCodeByUserId = await getReferralCodeByUserId(dynamicId);
        const userAnswers = userMetaDetails?.userAnswers;

        let allQuestions = [];
        if (userDetails.role === "Boat Owner") {
          allQuestions = userAnswers?.textQuestions || [];
        } else {
          const multiChoice = userAnswers?.multiChoiceQuestions || [];
          const textQuestions = userAnswers?.textQuestions || [];

          const maxLength = Math.max(multiChoice.length, textQuestions.length);

          for (let i = 0; i < maxLength; i++) {
            if (i < multiChoice.length) allQuestions.push(multiChoice[i]);
            if (i < textQuestions.length) allQuestions.push(textQuestions[i]);
          }
        }

        setReferralCode(ReferralCodeByUserId);
        setUserData(userDetails);
        updateUser({
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          role: userDetails.role,
          status: userDetails.status,
          phone: userDetails.phone,
          avatar: userDetails.avatar,
        });
        setAllQuestions(allQuestions);
        setRejectionReason(userDetails.rejectionReason);
        setUserMeta(userMetaDetails);
        setownerMeta(ownerMetaDetails);

        if (ownerMetaDetails && ownerMetaDetails.payoutAccounts) {
          setPayoutAccounts(ownerMetaDetails.payoutAccounts);
        }

        setInitialStatus(userDetails.status || "Pending");

        const verificationStatuses = {};
        const verificationRejections = {};
        Object.entries(userMetaDetails?.boatVerifications || {}).forEach(
          ([boatType, verification]) => {
            verificationStatuses[boatType] = verification?.status || "unset";
            verificationRejections[boatType] =
              verification?.rejectionReason || "";
          }
        );
        setBoatVerificationStatuses(verificationStatuses);
        setBoatVerificationRejections(verificationRejections);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [dynamicId]);

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    setInitialStatus(newStatus);

    // If you want to update the rejection reason immediately, you can still keep this line
    setRejectionReason("");
  };

  const updateProMemberStatus = (newStatus) => {
    // Update ownerMeta state with the new value of proMemberStatus
    setownerMeta((prevOwnerMeta) => ({
      ...prevOwnerMeta, // spread previous state
      proMemberStatus: newStatus, // update proMemberStatus
    }));
  };

  const handleApproveProMember = async () => {
    try {
      await updateProStaffStatus(dynamicId, "Approved");
      const memberDetails = await getUserByID(dynamicId);
      const database = getDatabase();
      const ownerMetaRef = ref(database, `refferalCodes`);
      const referCode = `⁠ ${memberDetails.firstName || ""}${
        memberDetails.lastName || ""
      } ⁠`.replace(/\s+/g, "");
      await push(ownerMetaRef, { code: referCode, userId: dynamicId });
      const applicantName =
        memberDetails.firstName + " " + memberDetails.lastName;
      const emailBody = await proMemberStatusBody(
        applicantName,
        "Approved",
        referCode
      );
      sendEmail(
        memberDetails.email,
        "Pro Member Application - Status",
        emailBody
      );
      updateProMemberStatus("Approved");
      const ownerMetaDetails = await getOwnerMetaByID(dynamicId);
      setownerMeta(ownerMetaDetails);
    } catch (error) {
      console.log("Error", error);
    }
  };
  const handleRejectProMember = async () => {
    try {
      await updateProStaffStatus(dynamicId, "Rejected");
      const memberDetails = await getUserByID(dynamicId);
      const applicantName =
        memberDetails.firstName + " " + memberDetails.lastName;
      const emailBody = await proMemberRejectedStatusBody(
        applicantName,
        "Rejected"
      );
      sendEmail(
        memberDetails.email,
        "Pro Member Application - Status",
        emailBody
      );
      updateProMemberStatus("Rejected");
      const ownerMetaDetails = await getOwnerMetaByID(dynamicId);
      setownerMeta(ownerMetaDetails);
    } catch (error) {}
  };

  const [updatedUserData, updateUser] = useState({
    firstName: "",
    lastName: "",
    age: "",
    phone: "",
    status: "",
    role: "",
  });

  const handleUpdateUser = (e) => {
    const { name, value } = e.target;
    updateUser((prevData) => ({ ...prevData, [name]: value }));
    console.log(updatedUserData);
  };

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const handleSave = async (event) => {
    try {
      event.preventDefault();
      setLoading(true);
      const userData = updatedUserData;
      const iniStatus = initialStatus;
      const newStatus = userData.status;
      const isRenter = userData.role === "Renter";

      // Renter verification is managed per boat type below — not via sidebar status.
      if (!isRenter && newStatus != iniStatus) {
        updateUserStatusById(dynamicId, newStatus, rejectionReason);

        const userName = userData.firstName + " " + userData.lastName;
        const originalUserData = await getUserByID(dynamicId);
        const userEmail = originalUserData.email;
        const url = process.env.REACT_APP_BASE_URL;

        if (newStatus == "Active") {
          const subject = `Congratulations! You're now verfied`;
          const bodyData = await OwnerVerificationApprovedEmailBody(
            userName,
            url
          );
          sendEmail(userEmail, subject, bodyData);
        } else if (newStatus == "Reject") {
          const subject = `You have received a new message from BBR`;
          const reason = rejectionReason;
          const bodyData = await OwnerVerificationRejectedEmailBody(
            userName,
            url,
            reason
          );
          sendEmail(userEmail, subject, bodyData);
        }
      }
      const userRef = ref(getDatabase(), `users/${dynamicId}`);
      await update(userRef, {
        firstName: userData.firstName,
        lastName: userData.lastName,
        phone: userData.phone,
        role: userData.role,
      });
      setLoading(false);
      setSuccess("User has been updated.");
      setTimeout(() => {
        setSuccess("");
      }, 1400);
    } catch (error) {
      console.error("Error updating user status:", error);
      setLoading(false);
    }
  };

  const handleBoatVerificationStatusChange = (boatType, newStatus) => {
    setBoatVerificationStatuses((prev) => ({
      ...prev,
      [boatType]: newStatus,
    }));
    if (newStatus !== "Reject") {
      setBoatVerificationRejections((prev) => ({
        ...prev,
        [boatType]: "",
      }));
    }
  };

  const handleBoatVerificationSave = async (boatType) => {
    try {
      setBoatVerificationLoading((prev) => ({ ...prev, [boatType]: true }));
      const newStatus = boatVerificationStatuses[boatType];
      const reason = boatVerificationRejections[boatType] || "";
      const originalStatus =
        userMeta?.boatVerifications?.[boatType]?.status || "unset";

      if (newStatus === originalStatus) {
        return;
      }

      await updateBoatVerificationStatus(
        dynamicId,
        boatType,
        newStatus,
        reason
      );

      const userName = `${userData.firstName} ${userData.lastName}`;
      const userEmail = userData.email;
      const url = process.env.REACT_APP_BASE_URL;

      if (newStatus === "Active") {
        const subject = `Congratulations! You're now verified for ${boatType}`;
        const bodyData = await RenterVerificationApprovedEmailBody(
          userName,
          url
        );
        sendEmail(userEmail, subject, bodyData);
        notifyRenterVerificationApproved(dynamicId).catch((err) =>
          console.error("Failed to create renter notification:", err)
        );
      } else if (newStatus === "Reject") {
        const subject = `You have received a new message from BBR`;
        const bodyData = await RenterVerificationRejectedEmailBody(
          userName,
          url,
          reason
        );
        sendEmail(userEmail, subject, bodyData);
        notifyRenterVerificationRejected(dynamicId).catch((err) =>
          console.error("Failed to create renter notification:", err)
        );
      }

      const refreshedMeta = await getUserMetaByID(dynamicId);
      setUserMeta(refreshedMeta);
      setSuccess(`${boatType} verification updated.`);
      setTimeout(() => setSuccess(""), 1400);
    } catch (error) {
      console.error("Error updating boat verification:", error);
    } finally {
      setBoatVerificationLoading((prev) => ({ ...prev, [boatType]: false }));
    }
  };

  if (!userData) {
    // You may want to display a loading spinner or message while data is being fetched
    return <div>Loading...</div>;
  }

  const hasBoatTypeVerifications =
    userData.role === "Renter" &&
    userMeta?.boatVerifications &&
    Object.keys(userMeta.boatVerifications).length > 0;
  const hasSignupProfileFields = Boolean(
    userData.highSchoolName ||
      userData.fishingTeamName ||
      userData.refferalCode
  );
  const showLegacyRenterQuestions = !hasBoatTypeVerifications;
  const showTopQuestionsCard =
    userMeta &&
    (userData.role !== "Renter" ||
      hasSignupProfileFields ||
      showLegacyRenterQuestions);
  const renterVerificationSummary =
    userData.role === "Renter"
      ? getRenterVerificationSummary(userData, userMeta)
      : null;

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };
  console.log("----->", ownerMeta);
  return (
    <>
      <div className="row">
        <div className="col">
          <div className="page-description">
            <h1>User</h1>
          </div>
        </div>
      </div>

      <section>
        <div>
          <div class="row">
            <div class="col-lg-4">
              <div className="row">
                <div className="col-12">
                  <div class="card mb-4">
                    <div class="card-body text-center">
                      <UserAvatar
                        src={userData && userData.avatar}
                        name={`${userData?.firstName || ""} ${userData?.lastName || ""}`}
                        size={150}
                        className="img-fluid"
                      />
                      <h5 class="my-3">
                        {userData.firstName} {userData.lastName}
                      </h5>
                      <p class="text-muted mb-1">{userData.bbrId}</p>
                      {userData.role === "Boat Owner" && (
                        <Button
                          as={Link}
                          to={`/dashboard/add-listing/for/${dynamicId}`}
                          className="btn btn-primary mt-3"
                        >
                          Add Boat for this Owner
                        </Button>
                      )}
                      {/* <p class="text-muted mb-1">{userData.role}</p> */}
                      <div class="d-flex justify-content-center mb-2 mt-4">
                        <select
                          className="form-select"
                          name="role"
                          style={{ width: "60%", marginTop: "-20px" }}
                          aria-label="Default select example"
                          value={updatedUserData.role}
                          onChange={(e) => handleUpdateUser(e)}
                        >
                          <option value="Boat Owner">Boat Owner</option>
                          <option value="Renter">Renter</option>
                          <option value="Admin">Admin</option>
                        </select>
                      </div>
                      {userData.role === "Renter" && renterVerificationSummary && (
                        <div className="renter-sidebar-verification mt-3 mb-2">
                          <span
                            className={`all-renters-status-pill all-renters-status-pill--${renterVerificationSummary.status}`}
                          >
                            {renterVerificationSummary.label}
                          </span>
                          {renterVerificationSummary.detail ? (
                            <p className="renter-sidebar-verification-detail mb-0">
                              {renterVerificationSummary.detail}
                            </p>
                          ) : (
                            <p className="renter-sidebar-verification-detail mb-0">
                              Approve or deny each boat type below.
                            </p>
                          )}
                        </div>
                      )}
                      <form onSubmit={handleSave}>
                        {userData.role !== "Renter" && (
                          <>
                            <div class="d-flex justify-content-center mb-2 mt-4">
                              <select
                                className="form-select"
                                name="status"
                                aria-label="Default select example"
                                value={updatedUserData.status}
                                onChange={(e) => handleUpdateUser(e)}
                              >
                                <option value="Pending">Pending</option>
                                <option value="Active">Approve</option>
                                <option value="Reject">Deny</option>
                              </select>
                            </div>
                            {updatedUserData &&
                              updatedUserData.status === "Reject" && (
                                <div className="d-flex justify-content-center mb-2 mt-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Denial reason"
                                    value={rejectionReason}
                                    required
                                    onChange={(e) =>
                                      setRejectionReason(e.target.value)
                                    }
                                  />
                                </div>
                              )}
                          </>
                        )}
                        <div className="">
                          {success && (
                            <Alert severity="success">{success}</Alert>
                          )}
                          <button
                            className="btn mt-2 btn-primary"
                            type="submit"
                          >
                            {loading ? (
                              <ThreeDots
                                visible={true}
                                height="22"
                                width="22"
                                color="#fff"
                                radius="20"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                              />
                            ) : (
                              "Update User"
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  {ownerMeta && ownerMeta.becomeProRequests && (
                    <>
                      {Object.values(ownerMeta.becomeProRequests).map(
                        (request, index) => (
                          <div key={index} className="row">
                            <div className="col-12">
                              <div className="card">
                                <div className="card-body">
                                  <Row>
                                    <Col xs={6}>
                                      <h5>Become Pro Request</h5>
                                      <p>
                                        {formatTimestamp(request.timestamp)}
                                      </p>
                                    </Col>
                                    <Col
                                      xs={6}
                                      className="d-flex align-items-center justify-content-end gap-3"
                                    >
                                      {ownerMeta.proStaffStatus ===
                                      "Pending" ? (
                                        <div className="d-flex gap-2">
                                          <Button
                                            onClick={handleApproveProMember}
                                          >
                                            Approve
                                          </Button>
                                          <Button
                                            onClick={handleRejectProMember}
                                            className="btn-danger"
                                          >
                                            Reject
                                          </Button>
                                        </div>
                                      ) : ownerMeta.proStaffStatus ===
                                        "Rejected" ? (
                                        <Alert severity="error">
                                          This Pro Staff Request has been
                                          rejected.
                                        </Alert>
                                      ) : ownerMeta.proStaffStatus ===
                                        "Approved" ? (
                                        <Alert severity="success">
                                          This Pro Staff Request has been
                                          Approved.
                                        </Alert>
                                      ) : (
                                        ""
                                      )}
                                    </Col>
                                  </Row>
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th style={{ width: "50%" }}>
                                          Question
                                        </th>
                                        <th style={{ width: "50%" }}>Answer</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {request?.formData &&
                                        (Array.isArray(request.formData)
                                          ? // Handle array format (from manual pro staff requests)
                                            request.formData.map(
                                              (data, dataIndex) => (
                                                <tr key={dataIndex}>
                                                  <td>{data.question}</td>
                                                  <td>{data.answer}</td>
                                                </tr>
                                              )
                                            )
                                          : // Handle object format (from automated signup)
                                            Object.entries(
                                              request.formData
                                            ).map(([key, value], dataIndex) => {
                                              // Skip non-relevant fields
                                              if (
                                                key === "password" ||
                                                key === "confirmPassword"
                                              )
                                                return null;
                                              return (
                                                <tr key={dataIndex}>
                                                  <td>{key}</td>
                                                  <td>
                                                    {typeof value === "object"
                                                      ? JSON.stringify(value)
                                                      : value}
                                                  </td>
                                                </tr>
                                              );
                                            }))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-3 d-flex align-items-center">
                      <p class="mb-0">First Name</p>
                    </div>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-solid-bordered"
                        value={updatedUserData.firstName}
                        name="firstName"
                        onChange={(e) => handleUpdateUser(e)}
                        label="First Name"
                      />
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-sm-3 d-flex align-items-center">
                      <p class="mb-0">Last Name</p>
                    </div>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-solid-bordered"
                        value={updatedUserData.lastName}
                        name="lastName"
                        onChange={(e) => handleUpdateUser(e)}
                      />
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-sm-3">
                      <p class="mb-0">Email</p>
                    </div>
                    <div class="col-sm-9">
                      <p class="text-muted mb-0">{userData.email}</p>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-sm-3 d-flex align-items-center">
                      <p class="mb-0">Phone</p>
                    </div>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        className="form-control form-control-solid-bordered"
                        value={updatedUserData.phone}
                        name="phone"
                        onChange={(e) => handleUpdateUser(e)}
                      />
                    </div>
                  </div>
                  <hr />
                  {/* <div class="row">
                  <div class="col-sm-3">
                    <p class="mb-0">Address</p>
                  </div>
                  <div class="col-sm-9">
                    {userMeta && <p class="text-muted mb-0">{userMeta.location}</p>}
                  </div>
                </div>
                <hr/> */}
                  {getDateOfBirthFromUserMeta(userMeta) && (
                    <>
                      <hr />
                      <div class="row">
                        <div class="col-sm-3">
                          <p class="mb-0">Date of Birth</p>
                        </div>
                        <div class="col-sm-9">
                          <p class="text-muted mb-0">
                            {getDateOfBirthFromUserMeta(userMeta)}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                  <hr />
                  <div class="row">
                    <div class="col-sm-3">
                      <p class="mb-0">Age</p>
                    </div>
                    <div class="col-sm-9">
                      {userMeta && (
                        <p class="text-muted mb-0">
                          {getUserAgeFromMeta(userMeta) ?? "—"}
                        </p>
                      )}
                    </div>
                  </div>
                  {referralCode && (
                    <>
                      <hr />
                      <div class="row">
                        <div class="col-sm-3">
                          <p class="mb-0">Refferal Code</p>
                        </div>
                        <div class="col-sm-9">
                          <p class="text-muted mb-0">{referralCode}</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {showTopQuestionsCard && (
                <div className="row">
                  <div className="col">
                    <div className="card p-3">
                      <table className="table">
                        <thead>
                          <tr>
                            <th style={{ width: "50%" }}>Question</th>
                            <th style={{ width: "50%" }}>Answer</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Display additional signup fields that are not basic profile info */}
                          {userData.highSchoolName && (
                            <tr>
                              <td>
                                <strong>High School Name</strong>
                              </td>
                              <td>{userData.highSchoolName || "Empty"}</td>
                            </tr>
                          )}
                          {userData.fishingTeamName && (
                            <tr>
                              <td>
                                <strong>Fishing Team Name</strong>
                              </td>
                              <td>{userData.fishingTeamName || "Empty"}</td>
                            </tr>
                          )}
                          {userData.refferalCode && (
                            <tr>
                              <td>
                                <strong>Referral Code Used</strong>
                              </td>
                              <td>{userData.refferalCode || "Empty"}</td>
                            </tr>
                          )}

                          {/* Legacy renter verification Q&A (hidden when boat-type verifications exist) */}
                          {showLegacyRenterQuestions &&
                            allQuestions.map((question, index) => (
                              <tr key={`question-${index}`}>
                                <td>{question.question || "No Question"}</td>
                                <td>{question.answer || "Empty"}</td>
                              </tr>
                            ))}

                          {showLegacyRenterQuestions &&
                            userMeta.userAnswers?.images?.map((image, index) => (
                              <tr key={`image-${index}`}>
                                <td>{image.question || "No Question"}</td>
                                <td>
                                  {image.answer ? (
                                    <img
                                      src={`${process.env.REACT_APP_BASE_URL}/images/${image.answer}`}
                                      alt="Uploaded Document"
                                      style={{
                                        maxWidth: "150px",
                                        maxHeight: "150px",
                                      }}
                                    />
                                  ) : (
                                    "Empty"
                                  )}
                                </td>
                              </tr>
                            ))}

                          {/* Show message if no questions found */}
                          {!userData.highSchoolName &&
                            !userData.fishingTeamName &&
                            !userData.refferalCode &&
                            !allQuestions.length &&
                            (!userMeta.userAnswers?.images ||
                              userMeta.userAnswers.images.length === 0) && (
                              <tr>
                                <td
                                  colSpan="2"
                                  className="text-center text-muted"
                                >
                                  No questions and answers found for this user.
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
              {userData?.role === "Renter" &&
                userMeta?.boatVerifications &&
                Object.keys(userMeta.boatVerifications).length > 0 && (
                  <div className="row mt-3">
                    <div className="col">
                      <div className="card p-3">
                        <h5 className="mb-3">Boat Type Verifications</h5>
                        {sortBoatVerificationsForAdmin(
                          Object.entries(userMeta.boatVerifications)
                        ).map(
                          ([boatType, verification]) => {
                            const answers = verification?.userAnswers || {};
                            const combinedQuestions = [
                              ...(answers.multiChoiceQuestions || []),
                              ...(answers.textQuestions || []),
                            ];

                            return (
                              <div
                                key={boatType}
                                className="border rounded p-3 mb-3"
                              >
                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                                  <h6 className="mb-0">{boatType}</h6>
                                  <span
                                    className={getAdminVerificationStatusClassName(
                                      verification?.status
                                    )}
                                  >
                                    Current:{" "}
                                    {getAdminVerificationStatusLabel(
                                      verification?.status
                                    )}
                                  </span>
                                </div>

                                <table className="table table-sm">
                                  <thead>
                                    <tr>
                                      <th>Question</th>
                                      <th>Answer</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {combinedQuestions.map((item, index) => (
                                      <tr key={`${boatType}-q-${index}`}>
                                        <td>{item.question || "No Question"}</td>
                                        <td style={{ whiteSpace: "pre-wrap" }}>
                                          {formatVerificationAnswerForDisplay(
                                            {
                                              questionType:
                                                inferVerificationQuestionType(
                                                  item.question
                                                ),
                                            },
                                            item.answer
                                          ) || "Empty"}
                                        </td>
                                      </tr>
                                    ))}
                                    {(answers.images || []).map(
                                      (image, index) => {
                                        const files = parseVerificationUploadedFiles(
                                          image.answer
                                        );

                                        return (
                                          <tr key={`${boatType}-img-${index}`}>
                                            <td>{image.question || "Proof"}</td>
                                            <td>
                                              {!files.length ? (
                                                "Empty"
                                              ) : (
                                                <div className="verification-readonly-files">
                                                  {files.map((file, fileIndex) => {
                                                    const fileName =
                                                      file.file || file.storedName || "";
                                                    const displayName =
                                                      file.name ||
                                                      file.originalName ||
                                                      fileName;
                                                    const isPdf = String(
                                                      fileName
                                                    )
                                                      .toLowerCase()
                                                      .endsWith(".pdf");

                                                    if (isPdf) {
                                                      return (
                                                        <a
                                                          key={`${fileName}-${fileIndex}`}
                                                          href={`${process.env.REACT_APP_BASE_URL}/images/${fileName}`}
                                                          target="_blank"
                                                          rel="noreferrer"
                                                          className="verification-readonly-file-link"
                                                        >
                                                          {displayName}
                                                        </a>
                                                      );
                                                    }

                                                    return (
                                                      <img
                                                        key={`${fileName}-${fileIndex}`}
                                                        src={`${process.env.REACT_APP_BASE_URL}/images/${fileName}`}
                                                        alt={displayName}
                                                        style={{
                                                          maxWidth: "150px",
                                                          maxHeight: "150px",
                                                        }}
                                                      />
                                                    );
                                                  })}
                                                </div>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>

                                <div className="d-flex flex-wrap gap-2 align-items-center">
                                  <select
                                    className="form-select"
                                    style={{ maxWidth: "220px" }}
                                    value={
                                      boatVerificationStatuses[boatType] ||
                                      verification?.status ||
                                      "Pending"
                                    }
                                    onChange={(e) =>
                                      handleBoatVerificationStatusChange(
                                        boatType,
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Pending">Pending</option>
                                    <option value="Active">Approve</option>
                                    <option value="Reject">Deny</option>
                                  </select>

                                  {boatVerificationStatuses[boatType] ===
                                    "Reject" && (
                                    <input
                                      type="text"
                                      className="form-control"
                                      style={{ maxWidth: "320px" }}
                                      placeholder="Enter denial reason"
                                      value={
                                        boatVerificationRejections[boatType] ||
                                        ""
                                      }
                                      onChange={(e) =>
                                        setBoatVerificationRejections(
                                          (prev) => ({
                                            ...prev,
                                            [boatType]: e.target.value,
                                          })
                                        )
                                      }
                                    />
                                  )}

                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() =>
                                      handleBoatVerificationSave(boatType)
                                    }
                                  >
                                    {boatVerificationLoading[boatType] ? (
                                      <ThreeDots
                                        visible={true}
                                        height="22"
                                        width="22"
                                        color="#fff"
                                        radius="20"
                                        ariaLabel="three-dots-loading"
                                      />
                                    ) : (
                                      `Update ${boatType}`
                                    )}
                                  </button>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>

          <div className="row">
            {payoutAccounts && (
              <div className="col">
                <div className="card p-4">
                  <h2>Payout Accounts</h2>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Account Type</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>Country</th>
                        <th>Currency</th>
                        <th>Email</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>State</th>
                        <th>Zip Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(payoutAccounts).map(
                        ([accountType, accountDetails]) => (
                          <tr key={accountType}>
                            <td>{accountType}</td>
                            <td>{accountDetails.accountHolderAddress}</td>
                            <td>{accountDetails.accountHolderCity}</td>
                            <td>{accountDetails.country}</td>
                            <td>{accountDetails.currency}</td>
                            <td>{accountDetails.accountHolderEmail}</td>
                            <td>{accountDetails.accountHolderFirst}</td>
                            <td>{accountDetails.accountHolderLast}</td>
                            <td>{accountDetails.accountHolderState}</td>
                            <td>{accountDetails.accountHolderZip}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
